<template>
  <div class="shade-chil">
    
    <i class="iconfont resource-icon">&#xe7c5;</i>
    <h1 class="resource-title">{{$t('message.产品列表')}}</h1>
    <div style="height: 578px border-bottom: 1px solid #ddd">
      <div class="resource">
        <div class="seek-box">
          <el-input
            type="text"
            :placeholder="$t('message.请输入搜索内容')"
            v-model="searchContentOnline"
            class="seek-main"
            @keyup.enter.native="doSearch()"
            @change="refresh"
            clearable
            :clear="doSearch()"
          />
          <i class="iconfont seek-icon" @click="doSearch()">&#xe7b4;</i>
        </div>
        <div id="resourceList"
          class="resourceList" 
          v-loading="loadingFlag"
          :element-loading-text="$t('message.拼命加载中')"
          element-loading-spinner="el-icon-loading">
          <el-table
            v-show="getMulti"
            ref="multipleTable"
            @sort-change="filterFunc"
            :data="getTableData"
            tooltip-effect="dark"
            :row-key='keyIndex'
            style="width: 100%"
            height="558"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              :selectable='isselected'
              :reserve-selection='true'
              width="55">
            </el-table-column>
            <el-table-column
              label="No."
              type="index"
              :index='indexm'
              width="55">
            </el-table-column>
            <el-table-column
              sortable
              prop="shelvesid"
              :label="$t('message.产品ID')"
              width="150">
            </el-table-column>
            <el-table-column
              sortable
              prop="name"
              :label="$t('message.产品名称')"
              min-width="150"
              >
            </el-table-column>
            <el-table-column
              sortable
              :label="$t('message.品牌名称')"
              min-width="150"
              prop="brandid"

              >
              <template slot-scope="scope">
                  <span>{{getBrandName(scope.row.brandid)}}</span>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('message.产品图片')" width="150" align="center">
              <template slot-scope="scope">
                  <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover">
                    <img :src="  scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                    <img slot="reference" :src=" scope.row.img" style="max-width: 120px; max-height: 30px">
                  </el-popover>
                  <span v-else>{{$t('message.无')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              sortable
              prop="state"
              :label="$t('message.产品状态')"
              >
              <template slot-scope="scope">
                <span>{{$t(`message.${getProductStateName(scope.row.state)}`)}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-show="!getMulti"
            ref="singleTable"
            :data="getTableData"
            @sort-change="filterFunc"
            tooltip-effect="dark"
            style="width: 100%"
            height="558"
            highlight-current-row
            @current-change="handleCurrentChange">
            <el-table-column
              label="No."
              type="index"
              :index='indexm'
              width="55">
            </el-table-column>
            <el-table-column
              sortable
              prop="shelvesid"
              :label="$t('message.产品ID')"
              width="150">
            </el-table-column>
            <el-table-column
              sortable
              prop="name"
              :label="$t('message.产品名称')"
              
              min-width="150"
              >
            </el-table-column>
            <el-table-column
              sortable
              :label="$t('message.品牌名称')"
              prop="brandid"
              min-width="150"
              >
              <template slot-scope="scope">
                  <span>{{getBrandName(scope.row.brandid)}}</span>
              </template>
            </el-table-column>
            <el-table-column  :label="$t('message.产品图片')" width="150" align="center">
              <template slot-scope="scope">
                  <el-popover v-if="scope.row.img != ''" placement="top-start" title="" trigger="hover" @show='showimg'>
                    <img :src=" scope.row.img" alt="" style="max-width: 500px; max-height: 500px">
                    <img slot="reference" :src=" scope.row.img" style="max-width: 120px; max-height: 30px">
                  </el-popover>
                  <span v-else>{{$t('message.无')}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="150"
              prop="state"
              sortable
              :label="$t('message.产品状态')"
              >
              <template slot-scope="scope">
                <span>{{getProductStateName(scope.row.state)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div>
            <!-- 放置分页组件区域 -->
        <pagination :pagesizeList='pageConfig.pagesizeList' :pagesize='sendData.pageConfig.pagesize' :total='pageConfig.total' :page='sendData.pageConfig.page' unsize='prev, pager, next' color='#f3f3f3'></pagination>
          </div>
    </div>
    <div class="myObject">
      {{ getTableData.length }} / {{ this.pageConfig.total +$t('message.个项目')}} 
    </div>
    <div class="on-btn">
      <el-button type="" size="mini" @click="refresh" icon="el-icon-refresh" round
        >{{$t('message.刷新')}}</el-button
      >
      <el-button type="" size="mini" @click="onButtonClick(0)" icon="el-icon-close" round
        >{{$t('message.关闭')}}</el-button
      >
      <el-button type="primary" size="mini" @click="onButtonClick(1)" icon="el-icon-check" round
        >{{$t('message.选择')}}</el-button
      >
    </div>
    <div class="selectToggle"></div>
  </div>
</template>

<script>
import shade from "@/components/shade/shade";
import commonUtil from "@/utils/commonUtil";

// 分页模块
import pagination from "@/components/pagination/pagination";
import {rejecthttp,changeflagCLOSED} from "@/utils/request";

export default {
  name: "shelvesStore",
  props: {
    // 是否使用复选
    ismulti: {
      type: Boolean,
      default: true,
    },
    // 排除对象列表
    excludeList: {
      type: Array,
      default: [],
    },
  },
  components: {
    shade,
    pagination,
  },
  data() {
    return {
      brandOptions: [
        {
          value: "0",
          label: "加载中..",
          disabled: true,
        },
      ],
      tableData: [],
      multipleSelection: [],
      currentRow: null,
      loadingFlag: false,
      search: "",
      searchContent: "",
      searchContentOnline: "",
      // 分页数据配置
      pageConfig: {
        pagesizeList: [20, 5, 10, 30, 40],
        pageSize: 10,
      },
      sendData: {
        appID: 188,
        filterConfig: {
          keyword: "",
          filterType: 1,
        },
        pageConfig: {
          page: 1,
          pagesize: 20,
          pageStartIndex: 0,
        },
        sortConfig: {
          order: "",
          prop: "",
        },
      },
      flag:0,
      lengthc:0
    };
  },
  methods: {
    showimg(){
    },
    indexm(i){
      console.log(3456)
        return (this.sendData.pageConfig.pagesize*(this.sendData.pageConfig.page-1)+1+i)
      },
    iscache(row) {},
    keyIndex(row) {
      return row.shelvesid;
    },
    isselected(row, index) {
      return !row.ischoosed;
    },
    // 子组件调用的方法，分页模块
    paginationChange(pagesize, page, name) {
      console.log(pagesize, page);
      console.log(this.multipleSelection);
      this.sendData.pageConfig.page =
        page != -1 ? page : this.sendData.pageConfig.page;
      this.sendData.pageConfig.pagesize =
        pagesize != -1 ? pagesize : this.sendData.pageConfig.pagesize;
      this.refresh();
    },
    // 排序的回调
    filterFunc(config) {
      // 获取点击的dom保存下来，等待翻页后继续留用
      // 获取dom元素
      this.sendData.pageConfig.page = 1;
      this.sendData.sortConfig.order = config.order;
      this.sendData.sortConfig.prop = config.prop;
      this.refresh();
      // 保存排序的dom标签
      // this.clickDom=orderDom
    },
    refresh() {
      this.sendData.filterConfig.keyword = this.searchContentOnline;
      rejecthttp(true,'get',"/manage/brand/getbrandlist",{
            appid: "188",
          },this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              doc.data.data.forEach((any) => {
              let item = {
                value: any.brandid,
                label: any.name,
              };
              this.brandOptions.push(item);
            });
            }
            })
      // this.$http
      //   .get("/manage/brand/getbrandlist", {
      //     params: {
      //       appid: "188",
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       console.log(doc.data);

      //       this.brandOptions = [];
      //       doc.data.data.forEach((any) => {
      //         let item = {
      //           value: any.brandid,
      //           label: any.name,
      //         };
      //         this.brandOptions.push(item);
      //       });
      //     }
      //   });
      rejecthttp(true,'post',"/manage/product/getproductlist",this.sendData,this,(doc) => {
            changeflagCLOSED(doc,0,this)
            if(doc.data.Code == "MSGKEY_OK"){
              this.pageConfig.total = doc.data.exData.datas;
            console.log(doc.data);
            this.tableData = doc.data.data;
            this.toggleSelection();
            }
            })
      // this.$http
      //   .post("/manage/product/getproductlist", this.sendData)
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       // 添加总条数
      //       this.pageConfig.total = doc.data.exData.datas;
      //       console.log(doc.data);
      //       this.tableData = doc.data.data;
      //       this.toggleSelection();
      //     }
      //   });
    },
    toggleSelection() {
      if (this.ismulti == true) {
        this.getTableData.forEach((row) => {
          if (row.ischoosed) {
            this.$refs.multipleTable.toggleRowSelection(row);
          }
        });
      }
    },
    onButtonClick(id) {
          this.flag=0
      if (id == 1) {
        if (this.ismulti == true) {
          console.log(this.multipleSelection)
          let cv=[]
          if(this.lengthc==-1){
            cv=[]
          }else{
            cv=this.multipleSelection.slice(this.lengthc,this.multipleSelection.length)
          }
          console.log(this.lengthc);
          let newclick=cv
          console.log(newclick);
          this.lengthc=-1
          this.$emit("onClick", { sel: newclick });
          
          // this.multipleSelection.splice(0, this.multipleSelection.length);
        } else {
        this.lengthc=-1
          this.$emit("onClick", { sel: this.currentRow });
        }
      } else {
        this.lengthc=-1
        this.$emit("onClick", {});
        
      }
      
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    getBrandName(id) {
      let result = "未选择";
      this.brandOptions.forEach((item) => {
        if (parseInt(item.value) == parseInt(id)) return (result = item.label);
      });
      return result;
    },
    getProductStateName(state) {
      return commonUtil.getProductStateName(state);
    },
    handleSelectionChange(val) {
      console.log(val)
      console.log(this.flag);
     
      console.log(this.lengthc);
      this.multipleSelection = JSON.parse(JSON.stringify(val));
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    doSearch() {
      this.search = this.searchContent.toLowerCase();
    },
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            !this.search ||
            data.shelvesid.toString().toLowerCase().includes(this.search) ||
            data.name.toLowerCase().includes(this.search) ||
            data.shelvesinfo.toLowerCase().includes(this.search) ||
            data.jumpurl.toLowerCase().includes(this.search) ||
            (data.brandid &&
              (data.brandid.toString().toLowerCase().includes(this.search) ||
                this.getBrandName(data.brandid)
                  .toLowerCase()
                  .includes(this.search)))
        );
      else return [];
    },
  },
  computed: {
    getMulti() {
      return this.ismulti;
    },
    getTableData() {
      let templist = [].concat(this.filterData());
      templist = JSON.parse(JSON.stringify(templist));
      this.ischoosedList = [];
      for (let i = 0; i < templist.length; i++) {
        let item1 = templist[i];
        this.excludeList.forEach((item2) => {
          if (item1.shelvesid == item2.shelvesid) {
            templist[i].ischoosed = true;
            console.log(templist[i]);
            console.log(templist[i].ischoosed);
            this.lengthc++
          } else if (item1.shelvesid != item2.shelvesid) {
            if (!templist[i].ischoosed) {
              templist[i].ischoosed = false;
            }
          }
        });
      }
      return templist;
    },
  },
  created() {
    this.refresh();
  },
  mounted() {
    // try{
    //    var shade=document.querySelectorAll('.shade')
    // console.log(shade[1])
    // shade=shade[1]
    // shade.style.zIndex='1000'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='999'
    // }catch(e){

    // }
   
  },
  destroyed() {
    // try{
    //    var shade=document.querySelectorAll('.shade')
    // shade=shade[1]
    // shade.style.zIndex='5999'
    // var center=shade.querySelector('.center')
    // center.style.zIndex='3000'
    // }catch(e){

    // }
   
  },
};
</script>

<style scoped>
.myObject {
  position: absolute;
  left: 22px;
  bottom: 20px;
  color: #303133;
}

.on-btn {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.resource-title {
  position: absolute;
  top: 15px;
  left: 48px;
  font-size: 18px;
  font-family: "微软雅黑";
  color: #303133;
  font-weight: 600;
}

.resource-icon {
  position: relative;
  top: -7px;
  font-size: 27px;
  color: #303133;
  margin-bottom: 20px;
}

.resource-icon:after {
  position: absolute;
  content: "";
  display: block;
  height: 90%;
  width: 0;
  border-left: 3px solid #303133;
  left: -10px;
  top: 2px;
}

.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
}

.shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);

  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.shade-chil .listBtn-box {
  position: absolute;
  width: 670px;
  height: 30px;
  line-height: 30px;
  /* border-right: 1px solid #ddd; */
  /* border-left   1px solid #ddd */
  padding-left: 10px;
  top: -37px;
  left: 3px;
  z-index: 1000;
}
.shade-chil .listBtn-box span a {
  color: #303133;
  font-size: 10px;
}

.shade-chil .listBtn-box span i {
  color: #303133;
  font-size: 10px;
}
.resource {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  /* top: 70px; */
  width: 100%;
  /* height 505px */
  /* border-top: 1px solid #ddd; */
  /* border-bottom  1px solid #ddd */
}

.seek-box {
  position: absolute;
  width: 330px;
  height: 40px;
  top: -42px;
  right: 0px;
  z-index: 10;
}

.seek-box /deep/ .el-input__inner {
  height: 35px;
}

.seek-main {
  width: 80%;
  height: 40px;
  font-size: 14px;
  color: #888;
  border: none;
}

.seek-icon {
  font-size: 28px;
  cursor: pointer;
  color: #303133;
  position: relative;
  top: 5px;
  margin-left: 0.1em;
}

.resourceList {
  width: 100%;
  height: 560px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* align-content: center; */
  align-content: flex-start;
  /* position: relative; */
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding-left: 20px;
}

.renameTextArea {
  position: relative;
  width: 80px;
  resize: none;
  overflow: visible;
  height: auto;
  background-color: #fff;
  z-index: 1001;
}

.renameTextAreaDialog {
  position: relative;
  width: 350px;
  height: 80px;
  resize: none;
  overflow: visible;
  background-color: #fff;
  border: 1px solid #ddd;
  z-index: 1001;
}
.shade-chil /deep/ .el-pagination .is-background{
  background-color: #f3f3f3!important;
}
</style>



// WEBPACK FOOTER //
// src/components/productStore/shelvesStore.vue